function openKlaviyoFormOnSubmitAndPosthog(response) {
  posthog.capture('user added to cart', {
    product_id: response.product_id,
    product_title: response.product_title,
    quantity: response.quantity,
  });
  // exits so popup code doesn't run
  return;
  
  // Checks if the referrer URL or current URL is free-first-kit
  if (document.referrer.includes("free-first-kit") || document.location.href.includes("free-first-kit")) {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'S5yLYn']);
    
    // Initialize the counter for the number of tries
    let attemptCount = 0;
    const maxAttempts = 3;

    // Function to check for the popup element and adjust z-index
    function setZIndexWhenPopupAppears() {
      const popupElement = document.querySelector('div[role="dialog"][aria-label="POPUP Form"]');
      
      if (popupElement) {
        popupElement.style.zIndex = '999999999999';  // Adjust z-index once element is found
      } else if (attemptCount < maxAttempts) {
        attemptCount++;  // Increment the number of attempts
        setTimeout(setZIndexWhenPopupAppears, 100);  // Check again after a short delay
      } else {
        console.log('Popup element not found after 3 attempts.');
      }
    }
    
    // Start checking for the popup after the form is opened
    setZIndexWhenPopupAppears();
  }
}

// Update the cart badge count from the cart-icon-bubble section response
function updateCartBadge(response) {
  var bubbleHtml = response.sections && response.sections['cart-icon-bubble'];
  if (!bubbleHtml) return;
  var doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
  var countEl = doc.querySelector('.cart-count-bubble span[aria-hidden]') || doc.querySelector('.cart-count-bubble span:not(.visually-hidden)');
  var itemCount = countEl ? parseInt(countEl.textContent, 10) : 0;

  // Update Dawn header badge
  var oldCount = document.querySelector('#cart-icon-bubble .cart-count-bubble');
  var newCount = doc.querySelector('.cart-count-bubble');
  if (newCount && oldCount) {
    oldCount.innerHTML = newCount.innerHTML;
  } else if (newCount && !oldCount) {
    var cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) cartLink.appendChild(newCount.cloneNode(true));
  }

  // Update Claymoo header badge (if present)
  var cmBadge = document.querySelector('#cart-icon-bubble .cm-header__cart-count');
  if (itemCount > 0 && cmBadge) {
    cmBadge.textContent = itemCount;
  }
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.dataset.silentAdd === 'true') {
        formData.append('sections', 'cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
      } else if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          if (this.dataset.silentAdd === 'true') {
            updateCartBadge(response);
            // Tell UpCart to refresh its contents so the next drawer open is up-to-date
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            window.dispatchEvent(new Event('cart:refresh'));
            // Animate button to checkmark
            const btn = this.submitButton;
            if (btn) {
              btn.classList.add('is-success');
              setTimeout(() => btn.classList.remove('is-success'), 1500);
            }
            return;
          }

          if (!this.cart) {
            if (typeof window.upcartOpenCart === 'function') {
              setTimeout(() => window.upcartOpenCart(), 500);
            } else {
              window.location = window.routes.cart_url;
            }
            return;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => {
                if (typeof window.upcartOpenCart === 'function') { window.upcartOpenCart(); }
                else { this.cart.renderContents(response); }
              }, 500);
            }, { once: true });
            quickAddModal.hide(true);
          } else if (typeof window.upcartOpenCart === 'function') {
            setTimeout(() => window.upcartOpenCart(), 500);
          } else {
            this.cart.renderContents(response);
          }
          // THIS IS THE KLAVIYO FORM FUNCTION
          openKlaviyoFormOnSubmitAndPosthog(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
